import React from 'react';

import Avatar from '@atlaskit/avatar';
import Heading from '@atlaskit/heading';
import EmailIcon from '@atlaskit/icon/glyph/email';
import LockIcon from '@atlaskit/icon/glyph/lock';
import { Text, Box, Stack, Inline } from '@atlaskit/primitives';
import {
  parseCommitAuthor,
  parseCommitEmail,
} from '@atlassian/bitbucket-user-profile';

import { messages } from 'src/components/settings/gpg-keys/gpg-keys.i18n';
import { Commit as CommitType } from 'src/components/types';
import { useIntl } from 'src/hooks/intl';

import { formatKeyID } from '../../../utils';

import {
  Content,
  InlineContent,
  IconWrapper,
  InlineGpgKeyContent,
  SignedByWrapper,
} from './verified-card.style';

export type GpgKeysVerifiedCardProps = {
  commit: CommitType;
};

export const GpgKeysVerifiedCardContent = ({
  commit,
}: GpgKeysVerifiedCardProps): JSX.Element | null => {
  const { formatMessage } = useIntl();
  const { author, extra } = commit;

  const email = parseCommitEmail(author.raw);
  const authorName = parseCommitAuthor(author.raw);

  return (
    <>
      <Box xcss={SignedByWrapper}>
        <Text size="small">{formatMessage(messages.verifiedSignedByText)}</Text>
      </Box>
      <Stack xcss={Content}>
        <Inline xcss={InlineContent}>
          <Avatar size="xsmall" src={author.user?.links.avatar.href} />
          <Heading level="h400" as="h5">
            {authorName}
          </Heading>
        </Inline>
        <Inline xcss={InlineContent}>
          <Box xcss={IconWrapper}>
            <EmailIcon label={formatMessage(messages.email)} size="small" />
          </Box>
          <Text>{email}</Text>
        </Inline>
        <Inline xcss={InlineGpgKeyContent}>
          <Box xcss={IconWrapper}>
            <LockIcon label={formatMessage(messages.gpgkey)} size="small" />
          </Box>
          <Stack>
            <Text>{formatMessage(messages.gpgkey)}</Text>
            <Text>
              {formatKeyID(extra?.verification?.fingerprint.slice(-16))}
            </Text>
          </Stack>
        </Inline>
      </Stack>
    </>
  );
};
